import Link from 'next/link'
import { Icon } from 'src/components/Icon'
import useWidth from 'src/hooks/useWidth'
import styles from './styles.module.scss'
import { intl } from 'src/i18n'

export const RelatedCoins = ({ relatedCoins, entity }) => {
  const { isMobile } = useWidth()
  return (
    <div className={styles.relatedCoins}>
      <span className={styles.header}>
        {intl.t('coinDetails.relatedCoins.title')}
      </span>
      <div className={styles.items}>
        {relatedCoins.map(i => {
          const { name, slug, symbol } = i
          return (
            <Link
              key={i.slug}
              href={`/coin/${i.slug}`}
              prefetch={false}
              legacyBehavior
            >
              <a className={styles.item}>
                <Icon
                  data={{ name, slug, symbol }}
                  size='16x16'
                  entity={entity}
                />
                <div className={styles.name}>
                  {name} {!isMobile && `(${symbol})`}
                </div>
              </a>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default RelatedCoins
